import { styled } from '@linaria/react'
import React, { type FC, type PropsWithChildren } from 'react'
import { useAppContext } from '../contexts/App.context'
import { WalletConnectionRequiredDialog } from '../dialogs/WalletConnectionRequiredDialog'

export const CreateBoxLayout: FC<PropsWithChildren> = ({ children }) => {
  const { wallet } = useAppContext()

  if (!wallet) {
    return (
      <CreateBoxLayoutContainer>
        <WalletConnectionRequiredDialog />
      </CreateBoxLayoutContainer>
    )
  }

  return <CreateBoxLayoutContainer>{children}</CreateBoxLayoutContainer>
}

const CreateBoxLayoutContainer = styled.div`
  height: 100%;
  flex-grow: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  grid-gap: 16px;
  padding-bottom: 16px;
`
